import Image from "next/image";

import CoffeIcon from "static/icons/coffee.svg";
import { POST_NEW_PARTNER_PROFILE } from "constants/routes";
import ButtonLink from "components/common/Links/ButtonLink/ButtonLink";
import classes from "./NoAnnouncementsInfo.module.css";
import useTranslation from "next-translate/useTranslation";

type Props = {
  text?: string;
  displayPostNewAnnouncementLink?: boolean;
  link?: string;
};

const NoAnnouncementsInfo = ({
  text,
  displayPostNewAnnouncementLink,
  link,
}: Props) => {
  const { t } = useTranslation("common");

  const url = link || POST_NEW_PARTNER_PROFILE;
  return (
    <div className={classes.content}>
      <div className={classes.icon}>
        <Image src={CoffeIcon} alt="" layout="responsive" />
      </div>
      <h4>{t("no_profile")}</h4>
      {text && <p>{text}</p>}
      {displayPostNewAnnouncementLink && (
        <ButtonLink href={url} className={classes.postNewAnnouncementLink}>
          {t("partner_profile.add")}
        </ButtonLink>
      )}
    </div>
  );
};

export default NoAnnouncementsInfo;
